/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The error code :
 *   * "00.XXX" : means that an HTTP error code has been return and must be taken into account
 *   * "10.XXX" : errors related to authorisation borne
 *   * "11.XXX" : errors related to transactions
 *   * "12.XXX" : errors related to stations
 *   * "50.XXX" : errors related to user management
 *   * "51.XXX" : errors related to user requests (forgotten password)
 *   * "52.XXX" : errors related to user vehicle management
 *   * "53.XXX" : errors related to user diffusion list management
 *   * "54.XXX" : errors related to technical accounts management
 *   * "60.XXX" : errors related to station management
 *   * "61.XXX" : errors related to agent management
 *   * "62.XXX" : errors related to alarm management
 *   * "63.XXX" : errors related to OPCUA connection management
 *   * "65.XXX" : errors related to OCPP connection management
 *   * "66.XXX" : errors related to partner operator
 *   * "67.XXX" : errors related to excel connection management
 *   * "70.XXX" : errors related to subscription management
 *   * "71.XXX" : errors related to subscription plan management
 *   * "72.XXX" : errors related to auth support management
 *   * "73.XXX" : errors related to subscription report management
 *   * "80.XXX" : errors related to SVG files management
 *   * "81.XXX" : errors related to tag management
 *   * "82.XXX" : errors related to ticket management
 *   * "83.XXX" : errors related to indicator management
 *   * "85.XXX" : errors related to reporting
 *   * "99.XXX" : other errors
 */
export enum ErrorCode {
  _00_000 = '00.000',
  _10_001 = '10.001',
  _10_002 = '10.002',
  _10_003 = '10.003',
  _11_001 = '11.001',
  _11_002 = '11.002',
  _11_003 = '11.003',
  _12_001 = '12.001',
  _12_002 = '12.002',
  _12_003 = '12.003',
  _12_004 = '12.004',
  _12_005 = '12.005',
  _12_006 = '12.006',
  _12_007 = '12.007',
  _50_001 = '50.001',
  _50_002 = '50.002',
  _50_003 = '50.003',
  _50_004 = '50.004',
  _50_005 = '50.005',
  _50_006 = '50.006',
  _50_007 = '50.007',
  _50_008 = '50.008',
  _50_009 = '50.009',
  _50_010 = '50.010',
  _50_011 = '50.011',
  _50_012 = '50.012',
  _50_013 = '50.013',
  _50_014 = '50.014',
  _51_001 = '51.001',
  _51_002 = '51.002',
  _52_001 = '52.001',
  _52_002 = '52.002',
  _52_003 = '52.003',
  _52_004 = '52.004',
  _52_005 = '52.005',
  _53_001 = '53.001',
  _53_002 = '53.002',
  _53_003 = '53.003',
  _53_004 = '53.004',
  _53_005 = '53.005',
  _53_006 = '53.006',
  _53_007 = '53.007',
  _54_001 = '54.001',
  _54_002 = '54.002',
  _60_001 = '60.001',
  _60_002 = '60.002',
  _60_003 = '60.003',
  _60_004 = '60.004',
  _60_005 = '60.005',
  _60_006 = '60.006',
  _60_007 = '60.007',
  _60_008 = '60.008',
  _60_009 = '60.009',
  _60_010 = '60.010',
  _60_011 = '60.011',
  _60_012 = '60.012',
  _60_013 = '60.013',
  _60_014 = '60.014',
  _61_001 = '61.001',
  _61_002 = '61.002',
  _61_003 = '61.003',
  _61_004 = '61.004',
  _62_001 = '62.001',
  _62_002 = '62.002',
  _62_003 = '62.003',
  _62_004 = '62.004',
  _63_001 = '63.001',
  _65_001 = '65.001',
  _65_002 = '65.002',
  _65_003 = '65.003',
  _66_001 = '66.001',
  _66_011 = '66.011',
  _67_001 = '67.001',
  _68_001 = '68.001',
  _68_002 = '68.002',
  _68_003 = '68.003',
  _68_004 = '68.004',
  _68_005 = '68.005',
  _68_006 = '68.006',
  _70_001 = '70.001',
  _70_002 = '70.002',
  _70_003 = '70.003',
  _70_004 = '70.004',
  _70_005 = '70.005',
  _70_006 = '70.006',
  _71_001 = '71.001',
  _71_002 = '71.002',
  _72_001 = '72.001',
  _72_002 = '72.002',
  _72_003 = '72.003',
  _72_004 = '72.004',
  _72_005 = '72.005',
  _73_001 = '73.001',
  _73_002 = '73.002',
  _73_003 = '73.003',
  _80_001 = '80.001',
  _80_002 = '80.002',
  _80_003 = '80.003',
  _80_004 = '80.004',
  _81_001 = '81.001',
  _81_002 = '81.002',
  _81_101 = '81.101',
  _81_201 = '81.201',
  _81_202 = '81.202',
  _82_001 = '82.001',
  _82_002 = '82.002',
  _82_003 = '82.003',
  _82_004 = '82.004',
  _82_005 = '82.005',
  _83_001 = '83.001',
  _83_002 = '83.002',
  _83_003 = '83.003',
  _85_001 = '85.001',
  _85_002 = '85.002',
  _85_003 = '85.003',
  _85_004 = '85.004',
  _85_005 = '85.005',
  _99_001 = '99.001',
  _99_002 = '99.002',
  _99_003 = '99.003',
  _99_004 = '99.004',
  _99_005 = '99.005',
  _99_006 = '99.006',
  _99_007 = '99.007',
  _99_999 = '99.999'
}
